import React, { FC } from 'react'
import { FightEvent } from 'web/data/models'
import { concat } from 'web/utils/utils'
import { WrappingDiv } from '../generic/WrappingDiv'
import { EventAssignment, EventAssignmentPayload } from './EventAssignment'

export const FightEventAssignments: FC<{

    fightEvent: FightEvent
    eventAssignments: EventAssignmentPayload[]

}> = ({ fightEvent, eventAssignments }) => {

    return (
        <WrappingDiv marginPx="4px" className="m-2 flex-shink-0" justify="end">
            {eventAssignments.map((item) => (
                <EventAssignment
                    key={concat([
                        fightEvent.id,
                        item.spellState.id,
                        item.playerState.id
                    ])}
                    eventAssignmentPayload={item} />
            ))}
        </WrappingDiv>
    )
}
